export class ValidationResult {
  errors: string[];
  isValid: boolean;

  constructor(isValid?: boolean) {
    this.errors = [];
    this.isValid = !isValid ? false : isValid;
  }
}
